define('views/content/cd_settings',['require','backbone','views/components/cd_settings/company_settings','views/components/cd_settings/profile_settings','views/components/cd_settings/password_settings','models/country_distributor','models/cd_manager','text!templates/content/cd_settings.html'],function(require){

    var Backbone = require('backbone');

    var CompanySettingsView = require('views/components/cd_settings/company_settings');
    var ProfileSettingsView = require('views/components/cd_settings/profile_settings');
    var PasswordSettingsView = require('views/components/cd_settings/password_settings');

    var CDModel = require('models/country_distributor');
    var CDManagerModel = require('models/cd_manager');

    var temp = require("text!templates/content/cd_settings.html");
    return Backbone.Marionette.LayoutView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'settings-page page',
        titleKey: 'settings',

        initialize: function () {
            App.context.changePageTitle(App.polyglot.t(this.titleKey));
        },

        regions: function() {
            return {
                CompanySettingsContainer: ".company-settings",
                ProfileSettingsContainer: ".profile-settings",
                PasswordSettingsContainer: ".password-settings"
            };
        },

        onRender: function () {
            var _this = this;

            var country_distributor = new CDModel({
                id: App.user.get('country_distributor')
            });

            country_distributor.fetch({
                success: function () {
                    _this.CompanySettingsContainer.show(new CompanySettingsView({
                        model: country_distributor
                    }));
                }
            });

            var manager = new CDManagerModel({
                id: App.user.get('id')
            });

            manager.fetch({
                success: function () {
                    _this.ProfileSettingsContainer.show(new ProfileSettingsView({
                        model: manager
                    }));
                }
            });

            _this.PasswordSettingsContainer.show(new PasswordSettingsView());
        }
    });
});
